function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconAmenitiesRefrigeratorFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 10h-2V6h2v4zm0 12h-2v-6h2v6zm10.941 3.942H9a1 1 0 01-1-1V14h15.941v10.94a1 1 0 01-1 1zM9 4h13.941a1 1 0 011 1v7H8V5a1 1 0 011-1zm13.941-2H9C7.345 2 6 3.346 6 5v19.94c0 1.655 1.345 3 3 3v2h3v-2h7.941v2h3v-2c1.654 0 3-1.345 3-3V5.002c0-1.655-1.346-3-3-3z",
    fill: props.color
  }));
}

export default SvgIconAmenitiesRefrigeratorFilled;